export default function canModifyRecipients(viewState) {
    var IRMData = viewState.IRMData;
    return !IRMData || IRMData.IsOwner || IRMData.ForwardAllowed;
}
//# sourceMappingURL=canModifyRecipients.js.map